module.exports = __webpack_public_path__ + "static/media/creation_site_web_LTM.96d0e5f6.doc";